import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-claims-list-page',
  templateUrl: './claims-list-page.component.html',
  styleUrls: ['./claims-list-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClaimsListPageComponent {

}
